import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import {
  getHotelByCity,
  GetHotelByCityAsync,
  GetTopHotelAsync,
  getTopHotels,
} from "../../features/bookings/hotelSlice";
import moment from "moment";

const settings = {
  // dots: true,
  // infinite: true,
  // speed: 500,
  // slidesToShow: 4,
  // slidesToScroll: 1,
  // margin: 10,
  // nextArrow: <SampleNextArrow />,
  // prevArrow: <SamplePrevArrow />,
  dots: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  margin: 10,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        // width: "40px",
        // height: "40px",
        background:
          "#fff url(./assets/images/right-blue-arrow.svg) center center no-repeat",
        // backgroundSize: "contain",
        // padding: "10px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        // width: "40px",
        // height: "40px",
        background:
          "#fff url(./assets/images/left-blue-arrow.svg) center center no-repeat",
        // backgroundSize: "contain",
        // padding: "10px",
      }}
      onClick={onClick}
    />
  );
}
const Intro = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const getHotelBycities = useSelector(getHotelByCity);
  const getTopHotel = useSelector(getTopHotels);
  const [hotelWithCity, setHotelWithCity] = useState([]);
  const [topHotels, setTopHotels] = useState([]);

  useEffect(() => {
    dispatch(GetHotelByCityAsync());
    dispatch(GetTopHotelAsync());
  }, []);

  useEffect(() => {
    if (getHotelBycities.length > 0) {
      setHotelWithCity(getHotelBycities);
    }
  }, [getHotelBycities]);

  useEffect(() => {
    if (getTopHotel.length > 0) {
      setTopHotels(getTopHotel);
      console.log({ getTopHotel });
    }
  }, [getTopHotel]);

  const LuxHotelHandler = (cityn, cityc) => {
    console.log("date", moment(new Date()).format("yyyy-MM-DD"));
    let guestDetails = JSON.stringify([
      {
        Adults: 1,
        Children: 0,
        ChildrenAges: [],
      },
    ]);

    let state = {
      city: cityc,
      checkIn: moment(new Date()).format("yyyy-MM-DD"),
      checkOut: moment(new Date()).add(1, "days").format("yyyy-MM-DD"),
      Nationality: "AE",
      cityname: cityn,
      guestDetails: guestDetails,
    };

    navigate({
      pathname: "/hotel-listing",
      search: `${createSearchParams(state)}`,
    });
  };

  const topHotelHandler = (cityn, cityc, hotelId) => {
    let guestDetails = JSON.stringify([
      {
        Adults: 1,
        Children: 0,
        ChildrenAges: [],
      },
    ]);

    let state = {
      city: cityc,
      checkIn: moment(new Date()).format("yyyy-MM-DD"),
      checkOut: moment(new Date()).add(1, "days").format("yyyy-MM-DD"),
      Nationality: "AE",
      cityname: cityn,
      guestDetails: guestDetails,
      hotelId: hotelId,
    };

    navigate({
      pathname: "/hotel-details",
      search: `${createSearchParams(state)}`,
    });
  };

  return (
    <>
      <section className="selection p-100 pt-0 mt-5">
        <div className="container">
          <div className="row">
            <div className="selection-wrap">
              <div className="row">
                <div className="col-xl-4 col-lg-12">
                  <div className="selection-inner-wrap">
                    <h5>Introducting</h5>
                    <h2 className="title">Luxe Selection</h2>
                    <p>
                      Escape to the epitomeof luxury, Packed with Signature
                      amenities and Services
                    </p>
                    <button className="cmn-btn">Load More</button>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-12">
                  <div className="row justify-content-center">
                    {hotelWithCity?.length > 0 &&
                      hotelWithCity.map((ele, ind) => (
                        <div className="col-lg-4 col-md-6">
                          <div
                            className="selection-inner"
                            onClick={() =>
                              LuxHotelHandler(ele.city_name, ele.citycode)
                            }
                          >
                            <div className="selection-img-wrap">
                              <img src={ele.image} alt="selection-img" />
                            </div>
                            <div className="selection-detail-wrap">
                              <h6>{ele.title}</h6>
                              <p> {ele.city_name}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="attraction p-100 pt-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-title-page">
                <h2 className="title">Attractions</h2>
                <p className="reg-gray-20">
                  These popular destinations have a lot to offer
                </p>
              </div>
            </div>

            <Slider {...settings}>
              {topHotels.length > 0 &&
                topHotels.map((ele, ind) => (
                  <div>
                    <a
                      className="attraction-main-wrap"
                      onClick={() =>
                        topHotelHandler(ele.cityname, ele.citycode, ele.id)
                      }
                    >
                      <div className="attraction-img-wrap">
                        <img
                          src={ele?.Hotel_Images?.[0]?.image}
                          alt={ele?.name}
                        />

                        <span className="location-badge">
                          📍 {ele?.cityname}
                        </span>
                      </div>

                      <div className="attraction-content">
                        <h4>{ele?.name}</h4>

                        <p>
                          Discover one of the best places to stay in{" "}
                          {ele?.cityname}
                        </p>
                      </div>
                    </a>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default Intro;
